<template>
    <div class="vx-card p-8">
        <div class="vx-row">
            <div class="vx-col md:w-6/12 mt-2">
                <h3>Danh sách nhân sự</h3>
            </div>
            <div class="vx-col md:w-6/12 w-full">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button icon="icon-trash-2" icon-pack="feather" v-if="selected.length > 0 && isPermissionDelete()" color="primary"
                        class="ml-auto" @click="confirmDeleteMulti">Xóa nhiều</vs-button>
                    <vs-button icon="icon-plus" icon-pack="feather" class="ml-4 mr-4" color="primary"
                        @click="activePopupOnLeave" v-if="isPermissionAdd()">Tạo mới
                    </vs-button>

                </div>
            </div>

        </div>
        <div class="w-full">
            <vs-table stripe multiple v-model="selected" max-items="10" pagination :data="employeeOnLeaves" search
                :key="currentPage" :noDataText="'Không có dữ liệu'">
                <template slot="thead">
                    <vs-th>STT</vs-th>
                    <vs-th>MÃ NHÂN VIÊN</vs-th>
                    <vs-th>
                        <vs-dropdown class="cursor-pointer">
                            <a class="a-icon flex" href="#" style="color: #626262;font-size: .85rem;font-weight: 750;">
                                TÊN NHÂN VIÊN
                                <!-- <vs-icon class="" icon="expand_more"></vs-icon> -->
                            </a>
                            <!-- <span v-if="departmentName !== 'Tất cả'" style="font-size: 12px; color: #b9b9c3;">
                                {{ departmentName }}</span> -->
                            <!-- <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(card, indexCard) in listDepartment" :key="indexCard"
                                    class="w-full border-bottom  py-1 px-2 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="getDetailDepartment(card)">
                                    {{ card.label }}
                                </vs-dropdown-item>
                            </vs-dropdown-menu> -->
                        </vs-dropdown>
                    </vs-th>
                    <vs-th>
                        <vs-dropdown class="cursor-pointer">
                            <a class="a-icon flex" href="#" style="color: #626262;font-size: .85rem;font-weight: 750;">
                                CHÍNH SÁCH
                                <vs-icon class="" icon="expand_more"></vs-icon>
                            </a>
                            <span style="font-size: 12px; color: #b9b9c3;">{{ policyName }}</span>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(card, indexCard) in optionPolicyFe" :key="indexCard"
                                    class="w-full border-bottom  py-1 px-2 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="getDetailPolicy(card)">
                                    {{ card.label }}
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </vs-th>
                    <vs-th>PHÉP TRONG NĂM</vs-th>
                    <vs-th>PHÉP TỒN</vs-th>
                    <vs-th>PHÉP THÂM NIÊN</vs-th>
                    <vs-th>NGHỈ BÙ</vs-th>
                    <vs-th v-if="userInfo.userRole === 'organization'">
                        <vs-dropdown class="cursor-pointer">
                            <a class="a-icon flex" href="#" style="color: #626262;font-size: .85rem;font-weight: 750;">
                                ĐƠN VỊ TRỰC THUỘC
                                <vs-icon class="" icon="expand_more"></vs-icon>
                            </a>
                            <span style="font-size: 12px; color: #b9b9c3;">{{ branchNames }}</span>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(card, indexCard) in listBranchs" :key="indexCard"
                                    class="w-full border-bottom  py-1 px-2 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="getInfoBranch(card)">
                                    {{ card.label }}
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </vs-th>
                    <!-- <vs-th>
                        <vs-dropdown class="cursor-pointer">
                            <a class="a-icon flex" href="#" style="color: #626262;font-size: .85rem;font-weight: 750;">
                                PHÒNG BAN
                                <vs-icon class="" icon="expand_more"></vs-icon>
                            </a>
                            <span v-if="departmentName !== 'Tất cả'" style="font-size: 12px; color: #b9b9c3;">{{
                                    departmentName
                                }}</span>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(card, indexCard) in listDepartment" :key="indexCard" class="w-full border-bottom  py-1 px-2 cursor-pointer hover:bg-primary hover:text-white"
                                                  @click="getDetailDepartment(card)">
                                    {{ card.label }}
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </vs-th> -->
                    <vs-th>THÂM NIÊN
                    </vs-th>
                    <vs-th>HÀNH ĐỘNG</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="employeeDayOff" :key="indextr" v-for="(employeeDayOff, indextr) in data">

                        <vs-td :data="employeeDayOff.index">
                            {{ employeeDayOff.index }}
                        </vs-td>

                        <vs-td :data="employeeDayOff.employeeCode">
                            {{ employeeDayOff.employeeCode }}
                        </vs-td>

                        <vs-td :data="employeeDayOff.fullName">
                            <div class="vx-col">
                                <div class="vx-row bsty">
                                    {{ employeeDayOff.fullName }}
                                </div>
                                <!-- <div class="vx-row twentText">
                                    {{ employeeDayOff.departmentName }}
                                </div> -->
                            </div>
                        </vs-td>

                        <vs-td :data="employeeDayOff.policyName" class="text-primary">
                            {{ employeeDayOff.policyName }}
                        </vs-td>

                        <vs-td :data="employeeDayOff.currentLeave" class="text-primary">
                            <div class="flex">
                                {{ data[indextr].currentLeave }}
                                <div class="w-full text-right text-grey mr-4 ml-2">ngày</div>
                            </div>

                        </vs-td>

                        <vs-td :data="employeeDayOff.redundancyLeave" class="text-primary">
                            <div class="flex">
                                {{ employeeDayOff.redundancyLeave }}
                                <div class="w-full text-right text-grey mr-4 ml-2">ngày</div>
                            </div>
                        </vs-td>

                        <vs-td :data="data[indextr].seniorityLeave" class="text-primary">
                            <div class="flex">
                                {{ data[indextr].seniorityLeave }}
                                <div class="w-full text-right text-grey mr-4 ml-2">ngày</div>
                            </div>
                        </vs-td>

                        <vs-td :data="employeeDayOff.compensatoryLeave" class="text-primary">
                            <div class="flex">
                                {{ employeeDayOff.compensatoryLeave }}
                                <div class="w-full text-right text-grey mr-4 ml-2">ngày</div>
                            </div>
                        </vs-td>

<!--                        <vs-td :data="employeeDayOff.branchName">-->
<!--                            {{ employeeDayOff.branchName }}-->
<!--                        </vs-td>-->

                        <!-- <vs-td :data="employeeDayOff.departmentName">
                            {{ employeeDayOff.departmentName }}
                        </vs-td> -->

                        <vs-td :data="employeeDayOff.seniorityLeaveDTO" class="text-primary">
                            <div class="flex">
                                <span
                                    v-if="employeeDayOff.seniorityLeaveDTO && employeeDayOff.seniorityLeaveDTO.year !== 0">{{
                                            employeeDayOff.seniorityLeaveDTO.year
                                    }}
                                    <span class="text-grey text-right mr-2">năm</span> </span>
                                <span
                                    v-if="employeeDayOff.seniorityLeaveDTO && employeeDayOff.seniorityLeaveDTO.month !== 0">{{
                                            employeeDayOff.seniorityLeaveDTO.month
                                    }}
                                    <span class="text-grey text-right mr-2">tháng</span> </span>
                                <span
                                    v-if="employeeDayOff.seniorityLeaveDTO && employeeDayOff.seniorityLeaveDTO.days !== 0">{{
                                            employeeDayOff.seniorityLeaveDTO.days
                                    }}
                                    <span class="text-grey text-right">ngày</span> </span>
                            </div>
                        </vs-td>
                        <vs-td>
                            <div class="flex">
                                <vx-tooltip text="Chi tiết" color="primary" v-if="isPermissionViewDetails">
                                    <feather-icon svgClasses="w-4 h-4 text-primary" icon="EyeIcon"
                                        class="cursor-pointer" @click="getDetaiEmployeeOnLeave(employeeDayOff)" />
                                </vx-tooltip>
                                <vx-tooltip text="Chỉnh sửa" color="primary" v-if="isPermissionUpdate()">
                                    <feather-icon svgClasses="w-4 h-4 text-primary" icon="EditIcon"
                                        class="cursor-pointer ml-4" @click="editEmployeeOnLeave(employeeDayOff.id)" />
                                </vx-tooltip>
                                <vx-tooltip text="Xóa" color="primary" v-if="isPermissionDelete">
                                    <feather-icon svgClasses="w-4 h-4 text-primary" icon="TrashIcon"
                                        class="cursor-pointer ml-4"
                                        @click="confirmDeleateEmployeeOnLeave(employeeDayOff.id)" />
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>

        <div>
            <vs-popup :title="isUpdate ? 'Cập nhật thông tin nhân sự' : 'Thêm nhân sự'" :active.sync="activePopup">
                <div class="vx-row">
                    <!-- <div class="vx-col w-full">
                        <label class="vs-input--label">Phòng ban</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="selectedDepartment" :options="optionDepartment" :clearable="false"
                            v-validate="'required'" name="deparrtment" :disabled="isUpdate">
                            <span slot="no-options">{{ $t('menuNewsEvent.noRowsToShow') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('deparrtment') }}</span>
                    </div> -->

                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Nhân sự</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="selectedEmployee" :options="optionEmployee" v-validate="'required'"
                            :clearable="false" name="employee" :disabled="isUpdate">
                            <span slot="no-options">{{ $t('menuNewsEvent.noRowsToShow') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('employee') }}</span>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Chính sách</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="policyModel" :options="optionPolicy" v-validate="'required'"
                            :clearable="false" name="Chính sách">
                            <span slot="no-options">{{ $t('menuNewsEvent.noRowsToShow') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('Chính sách') }}</span>
                    </div>

                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Ngày có hiệu lực</label>
                        <span class="text-danger">*</span>
                        <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates"
                            v-model="employeeOnLeave.effectiveDate" name="Ngày có hiệu lực">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('Ngày có hiệu lực') }}</span>

                    </div>

                    <div class="vx-col w-full mt-4" v-if="employeeOnLeave.policyId">
                        <div class="w-full bg-primary" style="height:100px;border-radius:5px">
                            <div class="flex">
                                <div class="vx-col w-full mt-4">
                                    <feather-icon icon="AlertCircleIcon" svgClasses="w-6 h-6 ml-4 text-white"
                                        style="vertical-align:middle "></feather-icon>
                                    <span style="font-weight:bold" class="text-white">
                                        {{ policyModel.label }}
                                    </span>
                                </div>
                            </div>
                            <div class="flex mt-2">
                                <div class="vx-col md:w-1/2 w-full">
                                    <feather-icon icon="HeartIcon" svgClasses="ml-8 w-4 h-4 text-white"
                                        style="vertical-align:middle">
                                    </feather-icon>
                                    <span style="font-size:small; font-weight:bold" class="ml-2 text-white">Số ngày nghỉ
                                        trong
                                        năm</span>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="vx-col md:w-1/2 w-full ml-8">
                                    <span class="ml-8 text-white">{{ policyModel.annualLeave }} ngày</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/2 w-full">
                        <label class="vs-input--label">Phép tồn</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="employeeOnLeave.redundancyLeave"
                            v-validate="'required|decimal:1|min_value:0'" type="number" step="0.5" min="0"
                            @input="checkLeave(employeeOnLeave)" name="Phép tồn"></vs-input>
                        <span class="text-danger text-sm">{{ errors.first('Phép tồn') }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full">
                        <label class="vs-input--label">Phép chuẩn trong năm</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="employeeOnLeave.currentLeave"
                            v-validate="'required|decimal:1|min_value:0'" type="number" step="0.5" min="0"
                            @input="checkLeave(employeeOnLeave)" name="Phép trong năm"></vs-input>
                        <span class="text-danger text-sm">{{ errors.first('Phép trong năm') }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full mt-2">
                        <label class="vs-input--label">Phép thâm niên</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="employeeOnLeave.seniorityLeave"
                            v-validate="'required|decimal:1|min_value:0'" type="number" step="0.5" min="0"
                            @input="checkLeave(employeeOnLeave)" name="Phép thâm niên"></vs-input>
                        <span class="text-danger text-sm">{{ errors.first('Phép thâm niên') }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full mt-2">
                        <label class="vs-input--label">Nghỉ bù</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="employeeOnLeave.compensatoryLeave"
                            v-validate="'required|decimal:1|min_value:0'" type="number" step="0.5" min="0"
                            @input="checkLeave(employeeOnLeave)" name="Nghỉ bù"></vs-input>
                        <span class="text-danger text-sm">{{ errors.first('Nghỉ bù') }}</span>
                    </div>
                </div>

                <div class="vx-row mt-4"
                    v-if="employeeOnLeave.redundancyLeave || employeeOnLeave.currentLeave || employeeOnLeave.seniorityLeave || employeeOnLeave.compensatoryLeave">
                    <div class="vx-col w-full">
                        <div class="w-full px-5 py-4"
                            style="height:50px;border-radius:5px; background-color: #fcb71d14;border: 0.5px solid #fcb71d45;">
                            <feather-icon icon="CheckCircleIcon" svgClasses="w-6 h-6 text-primary"
                                style="vertical-align:top"></feather-icon>
                            <span class="ml-4" style="font-size:small">Tổng số ngày nghỉ: {{ totalLeaves }}</span>
                        </div>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col mt-4 w-full">
                        <label class="vs-input--label">Ghi chú</label>
                        <vs-textarea v-model="employeeOnLeave.description" name="Ghi chú" />
                        <span class="text-danger text-sm">{{ errors.first('Ghi chú') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mt-4 mb-2 md:w-1/2">
                        <vs-button icon="icon-plus" icon-pack="feather" class="w-full" @click="saveEmployeeOnLeave"
                            :disabled="!validateForm">{{
                                    `${isUpdate ? $t('button.update') :
                                        $t('button.create')}`
                            }}</vs-button>
                    </div>
                    <div class="vx-col w-full mt-4 mb-2 md:w-1/2">
                        <vs-button class="w-full" type="border" @click="closePopup">{{ $t('button.close') }}</vs-button>
                    </div>
                </div>
            </vs-popup>
        </div>


    </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import FeatherIcon from '../../../../components/FeatherIcon.vue';
import Pagination from "../../../ui-elements/Pagination.vue";
import {isAPI, isRouter} from '../../../../store/permission';
import {constAPI, constRouter} from '../../../../store/constant';

export default {
    components: {
        vSelect,
        FeatherIcon,
        Datepicker,
        Pagination
    },

    data() {
        return {
            currentPage: 0,
            userInfo: {},
            isUpdate: false,
            employeeDayOff: {},
            // totalLeaves: 0,

            //popup
            activePopup: false,

            // onLeave: {},
            selected: [],
            employeeOnLeave: {
                // departmentId: null
            },
            employeeOnLeaves: [],
            employeeDetail: {},

            listBranchs: [],
            // listDepartment: [],
            branchName: null,
            selectedOrganizationBrachId: null,
            policyName: 'Tất cả',
            branchNames: 'Tất cả',
            // departmentName: 'Tất cả',
            valueSelectedStatus: null,
            employeeList: [],
            optionEmployee: [],
            // optionDepartment: [],
            en: en,
            vi: vi,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },

            //policy
            optionPolicy: [],
            optionPolicyFe: [],
            policyValue: null,
            organizationId: null,
            organizationBranchId: null,
            selectedEmployeeValue: null,
        }
    },

    async created() {
        await this.getAllListBranch();
        // await this.getDepartment();
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let branchList = this.listBranchs;
        this.organizationBranchId = userInfo.organizationBranchId;
        this.organizationId = userInfo.organization.id;
        if (userInfo.userRole !== 'organization') {
            let branch = branchList.find(el => el.value === userInfo.organizationBranchId);
            this.branchName = branch.label;
            // this.levelBranch = branch.patch.split('/').length;
            this.selectedOrganizationBrachId = userInfo.organizationBranchId;
        }
        else {
            this.branchName = userInfo.username.toUpperCase();
            // this.levelBranch = 0;
            this.listBranchs.unshift({ label: 'Tất cả', value: null })
        }

        this.initScreen();
        this.userInfo = userInfo;
    },

    watch: {
        '$store.state.isUpdateOnLeave'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_ONLEAVE', false);
            }
        }

    },

    computed: {
        totalLeaves: {
            get() {
                let total = parseFloat(this.employeeOnLeave.redundancyLeave) + parseFloat(this.employeeOnLeave.currentLeave) +
                    parseFloat(this.employeeOnLeave.seniorityLeave) + parseFloat(this.employeeOnLeave.compensatoryLeave);
                return total ? total : 0.0;
            }
        },
        policyModel: {
            get() {
                let object = this.optionPolicy.find(el => el.value === this.employeeOnLeave.policyId);
                if (!object) return;
                return {
                    value: object.value,
                    label: object.label,
                    maximalLeave: object.maximalLeave,
                    annualLeave: object.annualLeave,
                }
            },
            set(object) {
                this.employeeOnLeave.policyId = object ? object.value : null;
            }
        },
        // selectedDepartment: {
        //     get() {
        //         let object = this.optionDepartment.find(el => el.value == this.employeeOnLeave.departmentId);
        //         if (!object) {
        //             return;
        //         }
        //         return {
        //             label: object.label,
        //             value: object.value
        //         }
        //     },
        //     set(obj) {
        //         this.employeeOnLeave.departmentId = obj ? obj.value : null;
        //         if (obj) this.loadEmployee(obj.value);
        //         this.selectedEmployeeValue = null;
        //     }
        // },

        selectedEmployee: {
            get() {
                if (this.isUpdate) {
                    let object = this.employeeList.find(el => el.employeeId === this.employeeOnLeave.employeeId);
                    if (!object) {
                        return;
                    }
                    return {
                        label: object.fullName,
                        value: object.employeeId
                    }
                } else {
                    let object = this.optionEmployee.find(el => el.value === this.employeeOnLeave.employeeId);
                    if (!object) {
                        return;
                    }
                    return {
                        label: object.label,
                        value: object.value
                    }
                }
            },
            set(obj) {
                this.employeeOnLeave.employeeId = obj ? obj.value : null;
                if (obj.startWork) this.employeeOnLeave.startWork = obj.startWork;
            }
        },

        validateForm() {
            return !this.errors.any()
        },

    },

    mounted() {
        this.$eventBus.$on('UPDATE_ONLEAVE', () => {
            this.initScreen();
        });
    },

    methods: {
        isPermissionAdd() {
            return isAPI(this, constAPI.on_leave_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.on_leave_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.on_leave_delete)
        } ,
        isPermissionViewDetails() {
            return isRouter(this, constRouter.on_leave_details)
        },
        getDepartment: function (id) {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const payload = {
                    organizationBranchId: id ? id : userInfo.employeeId,
                    organizationId: this.employeeDetail.organizationId ? this.employeeDetail.organizationId : userInfo.organization.id,
                }
                this.$crm.post('/department/find-by-condition', payload).then((res) => {
                    this.listDepartment = res.data.map(el => {
                        return {
                            label: el.departmentName,
                            value: el.id
                        }
                    })
                    this.listDepartment.unshift({ label: 'Tất cả', value: null })
                    resolve();
                }).catch((err) => {
                    reject();
                    return this.$vs.notify({
                        title: this.$t('message.error'),
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        async activePopupOnLeave(el) {
            el.preventDefault();
            this.activePopup = true;
            this.isUpdate = false;
            this.employeeOnLeave = {
                employeeId: null,
                policyId: null,
                // departmentId: null,
                redundancyLeave: 0,
                currentLeave: 0,
                seniorityLeave: 0,
                compensatoryLeave: 0,
            }

            // this.employeeOnLeave.departmentId = this.optionDepartment[0].value;
            // this.loadEmployee(this.employeeOnLeave.departmentId);

            this.$validator.reset();

        },
        // getDetailDepartment(obj) {
        //     this.departmentName = obj.label;
        //     this.employeeDetail.departmentId = obj.value;
        //     const payload = {
        //         departmentId: this.employeeDetail.departmentId,
        //         policyId: this.employeeDetail.policyId,
        //         organizationBranchId: this.employeeDetail.organizationBranchId ? this.employeeDetail.organizationBranchId : this.organizationBranchId,
        //         organizationId: this.employeeDetail.organizationId ? this.employeeDetail.organizationId : this.organizationId
        //     }
        //     this.filterOnLeave(payload);
        // },
        getDetailPolicy(obj) {
            this.policyName = obj.label;
            this.employeeDetail.policyId = obj.value;
            const payload = {
                // departmentId: this.employeeDetail.departmentId,
                policyId: this.employeeDetail.policyId,
                organizationBranchId: this.employeeDetail.organizationBranchId ? this.employeeDetail.organizationBranchId : this.organizationBranchId,
                organizationId: this.employeeDetail.organizationId ? this.employeeDetail.organizationId : this.organizationId
            }
            this.filterOnLeave(payload);
        },
        getInfoBranch(obj) {
            // this.employeeDetail.departmentId = null
            this.branchNames = obj.label
            this.employeeDetail.organizationBranchId = obj.value;
            const payload = {
                // departmentId: this.employeeDetail.departmentId,
                policyId: this.employeeDetail.policyId,
                organizationBranchId: this.employeeDetail.organizationBranchId,
                organizationId: this.employeeDetail.organizationId
            }
            this.filterOnLeave(payload);
            // this.departmentName = 'Tất cả';
            // this.employeeDetail.departmentId = null;
            // this.getDepartment(obj.value);
        },

        confirmDeleteMulti(id) {
            this.employeeDayOffId = id;
            this.$vs.dialog({
                title: 'Xóa nhân viên',
                text: 'Bạn có chắc chắn muốn xóa thông tin những nhân viên này?',
                color: 'danger',
                accept: this.deleteMulti,
                acceptText: 'Xóa',
                cancleText: 'Hủy'
            });
        },

        deleteMulti() {
            this.$vs.loading();
            this.$crm.post('/on-leave/delete-all', this.selected).then(() => {
                this.selected = [];
                this.$vs.notify({
                    title: 'Thành công',
                    text: 'Xóa thành công',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                this.initScreen();
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            })
        },

        closePopup() {
            this.activePopup = false;
        },

        //get employee on leave
        getDataEmployeeOnLeave: function () {
            const payload = {
                organizationBranchId: this.organizationBranchId,
                organizationId: this.organizationId,
            }
            this.$vs.loading();
            this.$crm.post('/on-leave/find-by-condition', payload).then((response) => {
                let index = 1;
                this.employeeOnLeaves = response.data.map(el => {
                    el.index = index++;
                    return el;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        // filterDataByOrganizationBranchId: function (item) {
        //     this.branchName = null;
        //     this.selectedOrganizationBrachId = item.value;
        //     this.branchName = item.label;
        // },

        getAllListBranch: function () {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/organization-branch/all').then((response) => {
                    this.listBranchs = response.data.map(el => {
                        return {
                            label: el.organizationBranchName,
                            value: el.id,
                            patch: el.patch,
                            id: el.id,
                        }
                    });
                    this.$vs.loading.close();
                    resolve();
                }).catch(() => {
                    reject();
                    this.$vs.loading.close();
                });
            })
        },

        confirmDeleateEmployeeOnLeave(id) {
            this.employeeDayOffId = id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Xóa nhân viên',
                text: 'Bạn có chắc chắn muốn xóa nhân viên nghỉ này?',
                accept: this.deleteEmployeeOnLeave,
                acceptText: 'Xóa',
                cancleText: 'Hủy'
            });
        },

        deleteEmployeeOnLeave() {
            this.$vs.loading();
            this.$crm.post('/on-leave/delete/' + this.employeeDayOffId).then(() => {
                this.getDataEmployeeOnLeave();
                this.$vs.notify({
                    text: 'Xóa thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getDetaiEmployeeOnLeave(id) {
            let url = '/user/detail-on-leave';
            if (id)
                url = `${url}?employeeId=${id.employeeId}&policyName=${id.policyName}&fullName=${id.fullName}&organizationBranchId=${id.organizationBranchId}&organizationId=${id.organizationId}`;

            this.$router.push(url).catch(() => {
            })
        },
        editEmployeeOnLeave(id) {
            this.$validator.reset();
            this.activePopup = true;
            this.$vs.loading()
            this.$crm.post('/on-leave/find-by-id/' + id).then((response) => {
                this.isUpdate = true;
                this.employeeOnLeave = response.data;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        async initScreen() {
            await this.getEmployee();
            this.getPolicy();
            this.getDataEmployeeOnLeave();
            // this.getOptionDepartment();
        },

        filterOnLeave(payload) {
            this.$vs.loading();
            this.$crm.post('/on-leave/find-by-condition', payload).then((response) => {
                let index = 1;
                this.employeeOnLeaves = response.data.map(el => {
                    el.index = index++;
                    return el;
                });
                this.currentPage += 1;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        // getOptionDepartment() {
        //     const payload = {
        //         organizationBranchId: this.organizationBranchId,
        //         organizationId: this.organizationId,
        //     }
        //     this.$vs.loading();
        //     this.$crm.post('/department/find-by-condition', payload).then((response) => {
        //         this.optionDepartment = response.data.map(el => {
        //             return {
        //                 label: el.departmentName,
        //                 value: el.id,
        //             }
        //         })
        //         this.$vs.loading.close();
        //     }).catch((err) => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
        // },

        // loadEmployee(id) {
        //     const payload = {
        //         departmentId: id,
        //     }
        //     const payloads = {

        //     }
        //     this.$vs.loading();
        //     this.$crm.post('/on-leave/get-all-employee', this.isUpdate ? payloads : payload).then((response) => {
        //         this.optionEmployee = response.data.map(x => {
        //             return {
        //                 value: x.employeeId,
        //                 label: x.fullName,
        //             }
        //         })
        //         this.$vs.loading.close();
        //     }).catch((err) => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         });
        //     })
        // },

        getPolicy() {
            const payload = {
                organizationBranchId: this.organizationBranchId,
                organizationId: this.organizationId,
            }
            this.$vs.loading();
            this.$crm.post('/policy/find-by-condition', payload).then((response) => {
                this.optionPolicy = response.data.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                        maximalLeave: el.maximalLeave,
                        annualLeave: el.annualLeave,
                    }
                })
                this.optionPolicyFe = response.data.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                    }
                });
                this.optionPolicyFe.unshift({ value: null, label: 'Tất cả' });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        async getEmployee() {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
            const payload = {
                organizationBranchId: this.userInfo.organizationBranchId,
                pageSize: 1000,
                pageNumber: 0,
                sort: "id"
            }
            this.$vs.loading();
            this.$crm.post('/employee/find-by-condition', payload).then((response) => {
                this.employeeList = response.data.content;

                let result = response.data.content.filter(x => x.enabled === true)
                this.optionEmployee = result.map(el => {
                    return {
                        value: el.employeeId,
                        label: el.fullName,
                    }
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        onClickCloseButton(val) {
            this.$validator.reset();
            this.openPopup = false;
            this.$emit('closePopup', val)
        },
        async saveEmployeeOnLeave(el) {

            el.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (!this.checkLeave(this.employeeOnLeave)) {
                return;
            }

            let detail = this.employeeList.find(x => x.employeeId === this.employeeOnLeave.employeeId)
            this.employeeOnLeave.organizationBranchId = detail.organizationBranchId

            this.$vs.loading();
            let url = this.isUpdate ? '/on-leave/update' : '/on-leave/create';
            this.$crm.post(url, this.employeeOnLeave).then(() => {
                if (this.isUpdate) {
                    const payload = {
                        policyId: this.employeeDetail.policyId,
                        organizationBranchId: this.employeeDetail.organizationBranchId ? this.employeeDetail.organizationBranchId : this.organizationBranchId,
                        organizationId: this.employeeDetail.organizationId ? this.employeeDetail.organizationId : this.organizationId
                    }
                    this.filterOnLeave(payload);
                    this.$vs.notify({
                        text: 'Cập nhật thành công',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                } else {
                    this.initScreen();
                    this.$vs.notify({
                        text: 'Tạo thành công',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                }
                this.$vs.loading.close();
                this.closePopup(true);
            }).catch((err) => {
                this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                this.$vs.loading.close();
            })
        },

        checkLeave(employeeOnLeave) {
            if (employeeOnLeave.redundancyLeave % 0.5 !== 0 || employeeOnLeave.currentLeave % 0.5 !== 0 || employeeOnLeave.seniorityLeave % 0.5 !== 0 || employeeOnLeave.compensatoryLeave % 0.5 !== 0) {
                this.$vs.notify({
                    text: 'Số ngày phép phải là bội của 0.5',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                return false
            }
            return true
        },
    },
}
</script>

<style lang="scss">
.con-vs-popup .vs-popup {
    width: 40rem !important;
    height: auto !important;
}

.bsty {
    font-size: 1rem;
    color: black;
    font-weight: 500;
}

.twentText {
    font-size: 12px;
    color: #b9b9c3;
}
</style>
